import React from "react";
import "../../Assets/Css/HeroSection.css";
import bannerImage from "../../Assets/Images/BannerImage.png"; 

const HeroSection = () => {
    return (
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="hero-content">
          <h1>
            Bringing <br />
            <span>Stories</span> to Life <br />
            with <span>Passion</span> <br />
            and <span>Vision</span>
          </h1>
        </div>
      </section>
    );
  };
  
  export default HeroSection;
  
